<!--
 * @Autor: Aberg
 * @Date: 2021-10-12 10:47:33
 * @LastEditTime: 2022-09-27 14:08:43
 * @Description: 
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="news">
    <Header :columnName="columnName" />
    <div class="content">
      <ul class="news">
        <li v-for="(item, index) in list" :key="index">
          <p class="title dot" @click="goDetail(item.id, item.jump_url)">{{ item.title }}</p>
        </li>
      </ul>
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="pageInfo.page"
          :page-size="pageInfo.offset"
          layout="prev, pager, next"
          :total="total"
          :background="true"
        >
        </el-pagination>
      </div>
    </div>
    <Footer :showIcon="false" />
  </div>
</template>
<script>
import { article, topicOpt } from "@/service/api/home";
export default {
  name: 'news',
  data() {
    return {
      list: [],
      pageInfo: {
        page: 1,
        offset: 10
      },
      total: 0,
      columnId: '',
      columnName: ''
    }
  },
  created() {
    // console.log(1)
    this.columnId = this.$route.params.columnId
    this.columnName = this.$route.params.columnName
    this.getList()
  },
  methods: {
    getList() {
      let data = {
        'page': this.pageInfo.page,
        'offset': this.pageInfo.offset
      }
      if (this.columnName == '专题') {
        data['id'] = this.columnId
        topicOpt('list', data).then(res => {
          this.list = res.data.data
          // this.list = this.list.concat(res.data.data)
          // this.list = this.list.concat([res.data.data[0], res.data.data[1]])
          this.total = res.data.count
        })
      } else {
        data['column_id'] = this.columnId
        article(data).then(res => {
          this.list = res.data.data
          // this.list = this.list.concat(res.data.data)
          // this.list = this.list.concat([res.data.data[0], res.data.data[1]])
          this.total = res.data.count
        })
      }
      
    },
    goDetail(id, jump_url) {
      if (jump_url) {
        window.open(jump_url)
        return
      }
      this.$router.push(`/news/detail/${id}/${this.columnName}`)
    },
    //翻页
    handleCurrentChange(e) {
      this.pageInfo.page = e;
      this.getList()
    },
  }
}
</script>
<style lang="scss" scoped>
.content {
  box-sizing: border-box;
  min-height: calc(100vh - 2.5rem);
  // padding: 0.18rem 0.18rem 0.4rem;
  // position: relative;
  padding: 0.5rem 0 0.4rem;
  .news {
    box-sizing: border-box;
    width: 14rem;
    // min-height: 6.33rem;
    min-height: 5.9rem;
    // height: calc(100% - 1.15rem);
    // background: #fff;
    margin: 0 auto;
    overflow-y: auto;
    // padding: 0.45rem 0.55rem 0.4rem 0.58rem;
    li {
      box-sizing: border-box;
      font-size: 0.28rem;
      margin-bottom: 0.35rem;
      padding-left: 0.45rem;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0.12rem;
        width: 0.15rem;
        height: 0.15rem;
        background: #B9000B
      }
      &:last-child {
        margin-bottom: 0;
      }
      p {
        color: #333;
        cursor: pointer;
        &:hover {
          font-weight: bold;
        }
      }
    }
  }
  .block {
    width: 14rem;
    margin: 0.7rem auto 0;
    // position: absolute;
    // right: calc(50% - 6rem);
    // bottom: 0.4rem;
    text-align: center;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #B9000B !important;
  }
  /deep/ .el-pagination__total {
    display: none !important;
  }
}
</style>